import Keycloak from "keycloak-js";

let keycloakInstance = null;

const getKeycloak = () => {
  if (!keycloakInstance) {
    const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
    const realm = process.env.REACT_APP_KEYCLOAK_REALM;
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

    keycloakInstance = new Keycloak({
      url: keycloakUrl,
      realm: realm,
      clientId: clientId
    });
  }
  return keycloakInstance;
};

export default getKeycloak;
